import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)이 머리칸을 th 로 써서 본문 칸과 같은 글자로 맞춤. 칸 색은 인라인 style */
export const SerpIntermediaryReplaceRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& h2': {
    ...infoSectionTitleStyles,
    margin: '0 0 8px',
  },
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 720,
  },
  '& table + table': {
    marginTop: 16,
  },
  '& table th, & table td': {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  '& tbody th': {
    fontWeight: 400,
  },
}));
